// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-404-js": () => import("/Users/itz/Documents/CodePlaygound/votetandem-site/votetandem-site/src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("/Users/itz/Documents/CodePlaygound/votetandem-site/votetandem-site/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

exports.data = () => import(/* webpackChunkName: "pages-manifest" */ "/Users/itz/Documents/CodePlaygound/votetandem-site/votetandem-site/.cache/data.json")

